import { Check, CloudOff, Loader2, RefreshCw, TriangleAlert } from 'lucide-react';

import { cn } from '@/lib/utils';
import type { SyncStatus } from '@/lib/doc/types';

const STATUS_CONFIG: Record<SyncStatus, { label: string; icon: typeof Check; className: string; spin?: boolean }> = {
  connecting: { label: 'Connecting…', icon: Loader2, className: 'text-muted-foreground', spin: true },
  synced: { label: 'Saved', icon: Check, className: 'text-emerald-600 dark:text-emerald-400' },
  saving: { label: 'Saving…', icon: RefreshCw, className: 'text-amber-600 dark:text-amber-400', spin: true },
  offline: { label: 'Offline', icon: CloudOff, className: 'text-amber-600 dark:text-amber-400' },
  error: { label: 'Sync error', icon: TriangleAlert, className: 'text-destructive' },
};

export function SyncStatusBadge({
  status,
  className,
  compact = false,
}: {
  status: SyncStatus;
  className?: string;
  compact?: boolean;
}) {
  const config = STATUS_CONFIG[status];
  const Icon = config.icon;

  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full px-2 py-0.5 text-xs font-medium tabular-nums select-none',
        'bg-muted/60',
        config.className,
        className,
      )}
      role="status"
      aria-label={`Sync status: ${config.label}`}
      title={`Document sync: ${config.label}`}
    >
      <Icon className={cn('h-3.5 w-3.5', config.spin && 'animate-spin')} aria-hidden />
      {!compact && <span className="hidden sm:inline">{config.label}</span>}
    </span>
  );
}
